import { render } from "./excelCommerce.vue?vue&type=template&id=3c49b8c4"
import script from "./excelCommerce.vue?vue&type=script&lang=js"
export * from "./excelCommerce.vue?vue&type=script&lang=js"

import "./excelCommerce.vue?vue&type=style&index=0&id=3c49b8c4&lang=css"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__